<template>
  <div>
    <v-card-actions class="text_box">
      <v-card-title>
        <div v-for="image in getProjectImages" :key="image.id">
          <v-card class="pa-2 ma-1" color="grey">
            <v-btn fab icon x-small @click="deleteImage(image)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-img height="100px" width="100px" :src="image.image_name"></v-img>
          </v-card>
        </div>
      </v-card-title>
    </v-card-actions>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectImageView",
  props: ["projectImageList"],
  computed: {
    ...mapGetters(["getProjectImages"]),
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "DeleteProjectImage",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async deleteImage(value) {
      await this.showLoadingProcess();
      try {
        const id = {id: value.id};
        await this.DeleteProjectImage(id);
        await this.closeLoading();
        await this.showSnackBar({
          text: `${value.image_id} image has been removed from Project`,
          color: DEFAULT_CONSTANTS.warn,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        console.log(err);
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    updateSnackBarProp(value) {
      this.snackbar = value;
    },
  },
};
</script>

<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
